import React from 'react';

const colors = [
  { id: 'RAL7016', name: 'Anthrazitgrau', hex: '#383E42' },
  { id: 'RAL8017', name: 'Schokoladenbraun', hex: '#45322E' },
  { id: 'RAL9006', name: 'Weißaluminium', hex: '#A5A8A6' },
  { id: 'RAL9016', name: 'Verkehrsweiß', hex: '#F1F0EA' },
];

const ColorSelector = ({ selectedColor, onColorChange }) => {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 mb-6">
      <h3 className="text-lg font-semibold text-gray-800 mb-4">Farbe wählen</h3>
      
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {colors.map((color) => (
          <button
            key={color.id}
            onClick={() => onColorChange(color.id)}
            className={`relative flex flex-col items-center p-4 rounded-lg border-2 transition-all duration-200 ${
              selectedColor === color.id
                ? 'border-emerald-500 bg-emerald-50'
                : 'border-gray-200 hover:border-gray-300 bg-white'
            }`}
          >
            {/* Color swatch */}
            <div
              className="w-16 h-16 rounded-lg shadow-md mb-3 border border-gray-200"
              style={{ backgroundColor: color.hex }}
            />
            
            {/* Color info */}
            <span className="text-xs font-medium text-gray-500">{color.id}</span>
            <span className="text-sm font-semibold text-gray-800 text-center">{color.name}</span>
            
            {/* Selected checkmark */}
            {selectedColor === color.id && (
              <div className="absolute top-2 right-2 w-5 h-5 bg-emerald-500 rounded-full flex items-center justify-center">
                <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                </svg>
              </div>
            )}
          </button>
        ))}
      </div>
      
      <p className="text-xs text-gray-500 mt-4 text-center">
        Alle Farben zum gleichen Preis. Weitere RAL-Farben auf Anfrage verfügbar.
      </p>
    </div>
  );
};

export default ColorSelector;
